import { CreditRuleCoin } from '@aibees/elephant/components';
import { Icon } from '@aibees/shared/components';
import { CreditUsageType } from '@aibees/shared/definition';
import { useBoolean } from '@aibees/shared/hooks';
import { Button } from '@mui/material';
import { memo } from 'react';
import { usePeopleAnalyzeProfile } from './hooks/use-people-analyze-profile';
import type { HomePeopleAnalysisProps as Props } from './types';

export const HomePeopleAnalysis = memo(({ className, id }: Props) => {
  const { handleAnalysis, buttonText, isLoading, isAnalyzed } =
    usePeopleAnalyzeProfile(id);

  const state = useBoolean();

  const handleMouseEnter = () => {
    state.onTrue();
  };

  const handleMouseLeave = () => {
    state.onFalse();
  };

  return (
    <>
      {!isAnalyzed && state.value && (
        <CreditRuleCoin
          className="CreditRuleCoin"
          type={CreditUsageType.CONTACT_ANALYSIS_REVEAL}
        />
      )}

      <Button
        size="small"
        variant="outlined"
        color={isLoading || isAnalyzed ? 'primary' : 'inherit'}
        startIcon={
          isLoading ? (
            <Icon name="loading-twotone-loop" />
          ) : isAnalyzed ? (
            <Icon name="view" />
          ) : undefined
        }
        onClick={handleAnalysis}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {buttonText}
      </Button>
    </>
  );
});

HomePeopleAnalysis.displayName = 'HomePeopleAnalysis';
